import _ from 'lodash'


let random = _.padStart(_.random(2, 97), 2, 0)

export function coverImage() {
  return {
    large: `https://s3-eu-west-1.amazonaws.com/myd-resources/cover_images/mydocumenta_${random}.jpg`,
    small: `https://s3-eu-west-1.amazonaws.com/myd-resources/cover_images/800x320/mydocumenta_${random}.jpg`,
  }
}
